
import React from 'react';

function Demo() {
  return (
    <section id="demo" className="section demo-section container">
      <h2>See BOSS in Action</h2>
      <div style={{textAlign: 'center' }}>
        <video width="80%" controls src="/assets/product-demo.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
      <p style={{textAlign: 'center', marginTop: '20px'}}><em>Watch how Sarah scaled her agency with BOSS</em></p>
    </section>
  );
}

export default Demo;
